export const info = {
  'seo.title': 'Analysegjennomgang — Ernæringskonsultasjon | Sofia og Elena',
  'seo.description': 'Detaljert gjennomgang av dine analyser, individuelt ernæringsvalg og livsstilsanbefalinger fra ekspert ernæringsfysiologer Sofia og Elena.',
  'seo.keywords': 'analysegjennomgang, ernæringskonsultasjon, individuell ernæring, helseanbefalinger',

  'hero.title': 'Analysegjennomgang',
  'hero.description': 'En detaljert gjennomgang av dine analyser med individuelle ernæringsanbefalinger og en personlig handlingsplan.',

  'section1.title': 'Hva er inkludert i tjenesten:',
  'section1.paragraph1': 'Vi gjennomfører en grundig gjennomgang av alle dine laboratorieanalyser og helseindikatorer, og identifiserer mangler, ubalanser og områder som trenger oppmerksomhet.',
  'section1.paragraph2': 'Basert på resultatene lager vi en personlig ernæringsplan skreddersydd spesielt for kroppens behov og helsemål.',

  'section2.title': 'Hvordan det fungerer:',
  'section2.item1': 'Du sender dine analyser',
  'section2.item2': 'Vi gjennomfører en detaljert gjennomgang',
  'section2.item3': 'Vi møtes til en konsultasjon',
  'section2.item4': 'Du mottar en personlig måltidsplan',

  'section3.title': 'Hvorfor velge oss:',
  'section3.paragraph1': 'Med to eksperter som gjennomgår analysene dine samtidig, får du et helhetlig perspektiv som dekker både ernæringsmessige og kosmetologiske aspekter av helsen din.',
  'section3.paragraph2': 'Vår tilnærming handler ikke om midlertidige løsninger — vi hjelper deg å forstå kroppen din slik at du kan ta informerte beslutninger om helsen din for livet.',

  'cta.title': 'Klar til å starte reisen til helse?',
  'cta.description': 'Bestill en konsultasjon og få en personlig ernæringsplan basert på dine analyser.',
  'cta.button': 'Velg pakke',
  'cta.buttonAria': 'Velg en pakke',
};